import React from 'react';

import { SVGComponentProps } from './svg.types';

const ProfileImageSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSVGProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSVGProps}
      >
        <path
          d="M0.724365 10.242V9.37971C0.740356 9.06557 0.841918 8.76178 1.01807 8.50118C1.19422 8.24058 1.43826 8.03309 1.72379 7.90114C4.46809 6.79882 7.53206 6.79882 10.2764 7.90114C10.5619 8.03309 10.8059 8.24058 10.9821 8.50118C11.1582 8.76178 11.2598 9.06557 11.2758 9.37971V10.242C11.2757 10.4731 11.23 10.702 11.1414 10.9154C11.0528 11.1289 10.923 11.3228 10.7594 11.4861C10.5958 11.6493 10.4017 11.7787 10.188 11.8669C9.97441 11.9551 9.74549 12.0003 9.51437 12H2.48579C2.25467 12.0003 2.02575 11.9551 1.81212 11.8669C1.59848 11.7787 1.40432 11.6493 1.24073 11.4861C1.07715 11.3228 0.947344 11.1289 0.858742 10.9154C0.77014 10.702 0.724478 10.4731 0.724365 10.242ZM6.00008 1.25371e-07C5.42026 -0.000169412 4.85342 0.171612 4.37123 0.493618C3.88905 0.815625 3.51319 1.27339 3.29118 1.80903C3.06918 2.34466 3.011 2.9341 3.12402 3.5028C3.23703 4.07149 3.51615 4.5939 3.92609 5.00396C4.33602 5.41401 4.85835 5.69329 5.42701 5.80647C5.99568 5.91965 6.58513 5.86164 7.12083 5.6398C7.65653 5.41795 8.11441 5.04222 8.43656 4.56013C8.7587 4.07804 8.93065 3.51125 8.93065 2.93143C8.93076 2.54651 8.85504 2.16534 8.70782 1.80968C8.5606 1.45403 8.34475 1.13087 8.07261 0.858648C7.80047 0.586428 7.47737 0.370487 7.12176 0.223159C6.76615 0.07583 6.385 1.08907e-07 6.00008 1.25371e-07Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default ProfileImageSVG;
